import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Grid from "@mui/material/Grid2";
import { Typography, Paper } from "@mui/material";

const styles = (theme) => ({
  grid: {
    background: theme.palette.background.default,
    justifyContent: "center",
  },
  paper: {
    paddingTop: 16,
    paddingBottom: 16,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginTop: theme.spacing(3),
    width: "95%",
  },
  secondaryAction: {
    paddingTop: theme.spacing(1),
  },
});

const Panel = ({ children, classes, title, action, secondaryAction }) => (
  <Grid container spacing={3} className={classes.grid}>
    <Paper className={classes.paper} elevation={4}>
      <Grid container direction="row" justifyContent="space-between">
        <Grid size={{ xs: 9 }}>
          {title && (
            <Typography variant="h5" component="h1">
              {title}
            </Typography>
          )}
        </Grid>
        <Grid size={{ xs: 3 }}>
          <Grid
            container
            direction="column"
            justifyContent="space-around"
            alignItems="flex-end"
          >
            {action}
            {secondaryAction ? (
              <div className={classes.secondaryAction}>{secondaryAction}</div>
            ) : null}
          </Grid>
        </Grid>
      </Grid>
      {children}
    </Paper>
  </Grid>
);

Panel.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  classes: PropTypes.object.isRequired,
  action: PropTypes.node,
  secondaryAction: PropTypes.node,
};

export default withStyles(styles)(Panel);
